/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE. 
*/

import { CosmosEnumLinkIcons } from "@cosmos/hygraph-schema";

import { EdsIcon, IconPosition } from "@components/elements";
import { css } from "@panda/css";

import { CosmosLink, CosmosText, CosmosTextVariantEnum } from "..";

import { TextLinkIconEnum } from "./TextLinkIcon.type";

export interface TextLinkAndChevronProps {
	label?: string | null;
	href?: string | null;
	icon?: TextLinkIconEnum | null;
	iconPosition?: IconPosition | null;
	textVariant?: CosmosTextVariantEnum | null;
}

export const TextLinkAndChevron = ({
	href = "",
	label,
	icon = "ChevronRight",
	iconPosition = "end",
	textVariant = CosmosTextVariantEnum.paragraphMD,
}: TextLinkAndChevronProps): React.JSX.Element | null => {
	if (!label || !href) return null;
	const words = label.split(" ");
	const lastWord = words.pop();
	if (words.length) {
		words.push("");
	}

	return (
		<CosmosLink
			href={href}
			className={css({
				color: "eds.text.link.primary.default",
				transition: `color token(animations.eds.duration.200) token(animations.eds.easing.easeInOutQuad)`,
				_hover: {
					color: "eds.text.link.primary.press",
				},
				"& span": {
					whiteSpace: "nowrap",
					display: "inline-flex",
					flexDirection: "row",
					alignItems: "center",
				},
				"& svg": {
					display: "inline",
					marginInline: "eds.dimension.4",
				},
			})}
			analytics={{
				eventCategory: "hyperlink",
				eventLabel: label || "",
				eventValue: {
					component: "TextLinkAndChevron",
					icon,
					href,
				},
			}}
		>
			{
				// Assigned default value of ChevronRight to icon so cast is safe
				<CosmosText variant={textVariant}>
					{iconPosition === "end" ? (
						<>
							{words.join(" ")}
							<span>
								{lastWord}
								<EdsIcon size="xs" icon={CosmosEnumLinkIcons.ChevronRight} />
							</span>
						</>
					) : (
						<>
							<EdsIcon size="xs" icon={CosmosEnumLinkIcons.ChevronRight} />
							{label}
						</>
					)}
				</CosmosText>
			}
		</CosmosLink>
	);
};
